module.exports = __webpack_public_path__ + "img/marmelaedchen-klucke_xs.a5ace189.jpg";